<template>
  <teleport v-if="showModal" to="body">
    <div class="relative z-50">
      <!-- Backdrop -->
      <div class="fixed inset-0 bg-black opacity-25"></div>

      <!-- Modal Container -->
      <div
        class="fixed inset-0 overflow-y-auto overflow-x-hidden outline-none focus:outline-none pointer-events-none"
      >
        <div class="flex min-h-full items-center justify-center p-4">
          <div
            v-on-click-outside="[
              onClickOutside,
              { ignore: ['.regular-modal'] },
            ]"
            :class="[
              'relative max-w-full regular-modal pointer-events-auto shadow-lg',
              wide
                ? 'w-[95vw] lg:w-[1400px] max-w-[1400px]'
                : 'w-[500px] lg:w-160',
            ]"
          >
            <!--content-->
            <div
              class="relative flex flex-col w-full bg-white rounded-lg outline-none focus:outline-none"
            >
              <!--header-->
              <div
                class="flex items-center justify-between pt-3 pb-2 px-5 bg-blueDianne rounded-t-lg text-white"
              >
                <slot name="header"> </slot>
                <button
                  v-if="!cannotClose"
                  class="ml-auto bg-transparent border-0 text-white/50 hover:text-white float-right"
                  @click.prevent="toggleModal()"
                >
                  <span
                    class="bg-transparent text-white w-6 text-xl block outline-none focus:outline-none"
                  >
                    <i class="fa-solid fa-xmark"></i>
                  </span>
                </button>
              </div>
              <!--body-->
              <div
                class="relative flex-auto regular-modal-body"
                :class="{ 'rounded-b-lg': hideFooter }"
              >
                <slot name="body"> </slot>
              </div>
              <!--footer-->
              <div
                v-if="!hideFooter"
                class="flex items-center justify-end px-4 py-3 bg-tiara-100 rounded-b-lg"
              >
                <slot name="footer"> </slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import { vOnClickOutside } from "@vueuse/components";

export default {
  name: "RegularModal",
  directives: {
    onClickOutside: vOnClickOutside,
  },
  inheritAttrs: false,
  props: {
    wide: Boolean,
    cannotClose: Boolean,
    showing: Boolean,
    hideFooter: Boolean,
  },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    onClickOutside() {
      if (!this.cannotClose) {
        this.showModal = false;
      }
    },
    toggleModal() {
      this.showModal = !this.showModal;
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>
